<template>
	<v-row style="background: linear-gradient(270deg, rgba(0,56,122,0.8) 10%, rgba(255,255,255,0) 100%);" class="pa-8 pl-2">
		<v-col>
			<h2 class='display-2 font-weight-thin text-uppercase ' v-text='title' />
		</v-col>
		<v-col xs='12' md='8' class='text-right'>
			<h3 class='text-uppercase font-weight-regular white--text' v-text='mainTitle' />
			<CountryChips :items='mainItems' color='secondary' />

			<template v-if='otherTitle && otherItems'>
				<v-divider class='ma-4' />

				<h3 class='text-uppercase white--text font-weight-thin' v-text='otherTitle' />
				<CountryChips :items='otherItems' color='secondary' outlined />
			</template>
		</v-col>
	</v-row>
</template>

<script>

export default {
	components: {
		CountryChips: () => import('@/components/n-collections/CountryChips'),
	},
	props: {
		title: String,
		mainTitle: String,
		mainItems: Array,
		otherTitle: String,
		otherItems: Array,
	},
}
</script>

<style lang="scss" scoped>
</style>